<template>
    <div>
        <!-- Begin Page Content -->
        <div class="symptom">
            <div class="row">
                <div class="col-md-12 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-header d-flex justify-content-between align-items-center border-0 bg-white">
                            <h1 class="d-flex justify-content-start align-items-center back-page"><i class="icon icon-chevron-down"></i>Back to Consultation</h1>
                            <form class="form-search position-relative single-post-search">
                                <button class="btn button search"><i class="icon icon-search"></i></button>
                                <input type="text" name="text" placeholder="Search Question" />
                            </form>
                        </div>
                        <div class="card-body single-page">
                            <h3>How often should I get a check-up?</h3>
                            <p>
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the
                                release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                            </p>
                            <p>
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s.
                            </p>
                            <p>
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five
                                centuries
                            </p>
                            <div class="like-section my-3 d-flex justify-content-center mt-5">
                                <div class="text-center">
                                    <h4>Was this article helpful?</h4>
                                    <ul class="d-flex justify-content-center align-items-center mt-3">
                                        <li class="yes"><a href="#">Yes</a></li>
                                        <li class="no"><a href="#">No</a></li>
                                    </ul>
                                    <p>0 Out Of 0 Found This Helpful</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="questions-section">
            <div class="row">
                <div class="col-md-12 col-12 mb-4">
                    <div class="bg-white border-radius-5 p-3">
                        <h2 class="text-left my-4 px-4">Related Questions</h2>
                        <div class="row no-gutters">
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left border-0">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left border-0">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left border-0">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "single-post",
        data() {
            return {};
        },
        created(){
           this.pageName('Related Question')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/consultant/single-post.vue